<h1 mat-dialog-title class="text-center">Add Email</h1>
<div mat-dialog-content>
  <div class="entry-forms">
    <div class="row">
        <div class="col-md-12">
            <label class="f-label">Name</label>
            <mat-form-field class="full-width" appearance="outline">
                <input type="text" matInput>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <label class="f-label">Email ID</label>
            <mat-form-field class="full-width" appearance="outline">
                <input type="text" matInput>
            </mat-form-field>
        </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-stroked-button color="primary" mat-dialog-close>Save New</button>
  <button mat-raised-button color="primary" mat-dialog-close cdkFocusInitial>Save</button>
</div>